import { useRef } from 'react';
import { Link } from 'react-router-dom';
import { useMotion } from '@/hooks/useEditorialMotion';
import { navLinks } from '@/mocks/home';

export default function Footer() {
  const ref = useRef<HTMLElement>(null);
  useMotion(ref);
  return (
    <footer ref={ref} className="bg-background-50 border-t border-background-300 pt-16 md:pt-24 pb-8">
      <div data-group data-m="foot" className="max-w-[1320px] mx-auto px-5 md:px-12 lg:px-16">
        <div className="flex flex-col lg:flex-row justify-between gap-12">
          <p className="font-heading font-semibold text-[56px] md:text-[88px] leading-[0.9] tracking-[-0.04em] text-foreground-950">NOVA</p>
          <div className="flex flex-wrap gap-x-16 gap-y-6 text-[14px] lg:pt-4">
            <ul className="space-y-3">
              {navLinks.map((l) => (
                <li key={l.label}><Link to={l.href} className="text-foreground-700 hover:text-foreground-950 whitespace-nowrap cursor-pointer">{l.label}</Link></li>
              ))}
            </ul>
            <ul className="space-y-3 text-foreground-700">
              <li>[Street address]</li>
              <li>[Phone number]</li>
              <li>[Email]</li>
              <li>[Social handle]</li>
            </ul>
          </div>
        </div>
        <div className="mt-14 pt-6 border-t border-background-300 flex flex-col sm:flex-row justify-between gap-2 text-[12px] text-foreground-600">
          <p>© 2026 NOVA Hair Studio. All rights reserved.</p>
          <p>Prices and details shown are placeholders.</p>
        </div>
      </div>
    </footer>
  );
}